webpackJsonp([0],{

/***/ "//2Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var b = 1;
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            compHeight: 0,
            coreHeight: 0,
            introHeight: 0,
            magHeight: 0,
            perHeight: 0,
            languages: ['繁體中文', '简体中文', 'ENGLISH'],
            headerLanguages: [{
                title: ['首頁', '首页', 'HOME'],
                link: '#chuangIntroduction',
                icon: __webpack_require__("Acex")
            }, {
                title: ['經營理念', '经营理念', 'MANAGEMENT PHILOSOPHY'],
                link: '#manageLink',
                icon: __webpack_require__("3gF9")
            }, {
                title: ['競爭優勢', '竞争优势', 'COMPETITIVE ADVANTAGE'],
                link: '#competitiveLink',
                icon: __webpack_require__("B2vO")
            }, {
                title: ['核心價值', '核心价值', 'CORE VALUE'],
                link: '#coreLinks',
                icon: __webpack_require__("3+r/")
            }, {
                title: ['招聘人才', '招聘人才', 'PERSONNEL RECRUITMENT'],
                link: '#personnelLink',
                icon: __webpack_require__("NqDs")
            }],
            showList: false,
            showLanguange: false,
            activeLink: 0,
            selectedLanguange: 0,
            isAnimateChangeLanguageOn: false
        };
    },

    methods: {
        startPageAnimation: function startPageAnimation(n) {
            this.$root.$emit('startPageAnimation', n);
        },
        show: function show(isShow) {
            if (isShow) {
                this.showList = true;
            } else {
                this.showList = false;
            }
        },
        changeLanguage: function changeLanguage(n) {
            this.showList = false;
            var _this = this;
            this.selectedLanguange = n;
            this.startChangeLangAnimation();
            this.showLanguange = false;
            this.$root.$emit('languageChange', n);
            this.$root.$emit('animageChangeLanguage', n);
        },
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            _this.isAnimateChangeLanguageOn = false;
        },
        isChineseChar: function isChineseChar(n) {
            var b = false;
            if (n == 0 && n == 1) {
                b = true;
            }
            return b;
        },
        isSelected: function isSelected(n) {
            var b = false;
            if (n == this.selectedLanguange) {
                b = true;
            }
            return b;
        },
        isActiveLink: function isActiveLink(n) {
            var b = false;
            if (n == this.activeLink) {
                b = true;
            }
            return b;
        },
        changeActiveLink: function changeActiveLink(n) {
            this.activeLink = n;
        },
        popModalShow: function popModalShow(b) {
            this.$root.$emit('popModalShow', b);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('updateIntroSize', function (e) {
            _this.introHeight = e;
        });
        this.$root.$on('updateMngSize', function (e) {
            _this.magHeight = e;
        });
        this.$root.$on('updateCompSize', function (e) {
            _this.compHeight = e;
        });
        this.$root.$on('updateCoreSize', function (e) {
            _this.coreHeight = e;
        });
        this.$root.$on('updatePerSize', function (e) {
            _this.perHeight = e;
        });
        this.$root.$on('closeLanguageSelection', function (e) {
            _this.showLanguange = e;
            _this.showList = e;
        });
        document.addEventListener('scroll', function (e) {
            var h = document.getElementById('chuangHeader').offsetHeight;
            var _scroll = e.target.scrollingElement.scrollTop;
            var first = _this.introHeight - h;
            var second = first + _this.magHeight - h + 85;
            var third = second + _this.compHeight - h + 85;
            var fourth = third + _this.coreHeight - h + 85;
            var fifth = fourth + _this.perHeight - h + 85;

            if (_scroll >= 0 && _scroll <= first) {
                _this.activeLink = 0;
            } else if (_scroll >= first && _scroll <= second) {
                _this.activeLink = 1;
            } else if (_scroll >= second && _scroll <= third) {
                _this.activeLink = 2;
            } else if (_scroll >= third && _scroll <= fourth) {
                _this.activeLink = 3;
            } else if (_scroll >= fourth && _scroll <= fifth) {
                _this.activeLink = 4;
            }
        });
    }
});

/***/ }),

/***/ "/TeD":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAjCAMAAADL21gSAAAAZlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+Vn2moAAAAIXRSTlMA9fnUHgrDKt3w2L9KRjMaFe3q6MkwFw8Nuk1BO7FRT98L0/L0AAAA6ElEQVQ4y43TWRKCMBAE0CQKbrgr+2Luf0kNE2mKDhT9xfS8AvIRtTpJE4UXUZMMxtgiCprCGq9KY60oNtaa0j2m2rqcIjKnfqFTN7QGio1pZeyg2HT/ohQV5zB5LKZElUCNjT8bKzbIWYvK3JCJ0WfZkXplP/MiQ4pMSMGEUokSU6EnRYZTa29qNZ/bRtDmtmxYsYFaNIfDgkq9qWuv0nlzUeoyp67HwQzqeA2auzNO3UmRCSiYN6r3VG33ffFwBurRl/stm7CC2alJdiMl9+sJA/WU++je9IFhhe/BkMKfx4MhFYtZkS+i5C5ND6SEFgAAAABJRU5ErkJggg=="

/***/ }),

/***/ "2eql":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var other = '...';
/* unused harmony default export */ var _unused_webpack_default_export = (other);

/***/ }),

/***/ "3+r/":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAXVBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysr521A1AAAAHnRSTlMA+KWSaEcE+4pd8ufJsJh8LBcJAlnXw1A3JyHZODZXJbU1AAAAyklEQVQ4y72S2w6DIBBEBbWiIKJ4b7v//5kNSm0cxaYvPS9q5sSww0a/Ir7kAw2X+a2j7nYlJESUXOSNJCLZhIWKHFUwr4tFKOqQENNKfB7bR+YFNlqczuRxX9CHoo9z854314rRGUzp3AnpFh+VdP1FFsizduvvnAQKQqpdAwC2YTkh3O6bKCEv8dZTENLjJuAEgABBoMDxjCgoEBQK0gd3/5S4jX64ZzT6gWEzJ3c33Czvhrvbm7AGpufta9YMi2hFvd9f0UZ/4wWhZSnu6MuRiAAAAABJRU5ErkJggg=="

/***/ }),

/***/ "3gF9":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAclBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysr1Pl5+AAAAJXRSTlMAYAPu4r0S+d7PwbedfDYpHxrz6saplYuEcWZIRTzl2rBVLy0IPF4OLQAAALJJREFUOMu9kkcOwlAMRH9JL6T30PH9r8gG8tsoERvedp40lm32E8HcxbL2/LGAsRglfckCN39cSUPe7fxEFrNVH5KNOYhPDr5ZACg1IUNCrgkXot2OihDekRAyRYuERuWvCAmpEhJC8C0fYF6LTSBIrxqm1MOL3B0iPToFN57p5gor04ld4WwIPMSConGExRQSPKQiyAderLowMYB2s6hEQv/5lC5fBENUsWwz/hTsr7wBHT9F5WsZ7mEAAAAASUVORK5CYII="

/***/ }),

/***/ "463W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            bgCh: __webpack_require__("wr+2"),
            bgeng: __webpack_require__("fzuy"),
            isAnimateChangeLanguageOn: false,
            coreTitleLanguages: ['核心價值', '核心价值', 'CORE VALUE'],
            coreDescriptionLanguages: ['快樂工作的氛圍、頂尖的技術科技、創新的思維，事業版圖持續拓展，以研製手遊為主，並在台灣、香港、中國、菲律賓、馬來西亞等地已有公司。正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，規畫著未來進軍歐美市場。 期許未來打造原創遊戲品牌，在台灣與海外市場佔有一席之地。', '快乐工作的氛围、顶尖的技术科技、创新的思维，事业版图持续拓展，以研制手游为主，并在台湾、香港、中国、菲律宾、马来西亚等地已有公司。正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，规画着未来进军欧美市场。 期许未来打造原创游戏品牌，在台湾与海外市场占有一席之地。', 'Happy working atmosphere, top technology,innovative thinking. We mainly develop online games, and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. One of our goals in to have a market in Europe and America in the near future.We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.'],
            selectedCoreImg: [],
            coreImg: [[__webpack_require__("ygJp"), __webpack_require__("v8LC"), __webpack_require__("OjsS")], [__webpack_require__("sMYk"), __webpack_require__("hdX9"), __webpack_require__("X9iX")]],
            clientWidth: 0,
            selectedLanguage: 0
        };
    },

    methods: {
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            setTimeout(function () {
                _this.isAnimateChangeLanguageOn = false;
            }, 1);
        },
        changeIntroBackground: function changeIntroBackground() {
            if (this.clientWidth <= 900) {
                this.$refs.coreBg.style.backgroundImage = "url(" + __webpack_require__("OaoU") + ")";
            } else if (this.clientWidth > 900) {
                this.$refs.coreBg.style.backgroundImage = "url(" + __webpack_require__("KXKi") + ")";
            }
        },
        changeCoreBackground: function changeCoreBackground() {
            if (this.clientWidth <= 900) {
                this.selectedCoreImg = this.coreImg[1];
            } else if (this.clientWidth > 900) {
                this.selectedCoreImg = this.coreImg[0];
            }
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
            _this.changeIntroBackground();
        });
        this.$root.$off('animageChangeLanguage', function (e) {
            _this.startChangeLangAnimation();
        });
        window.addEventListener('resize', function (e) {
            var h = document.getElementById('chuangCore').offsetHeight;
            _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
            _this.$root.$emit('updateCoreSize', h);
            _this.changeIntroBackground();
            _this.changeCoreBackground();
        });
        window.addEventListener('load', function (e) {
            var h = document.getElementById('chuangCore').offsetHeight;
            _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
            _this.$root.$emit('updateCoreSize', h);
            _this.changeIntroBackground();
            _this.changeCoreBackground();
        });
    }
});

/***/ }),

/***/ "4D7g":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/management-04.4feda94.png";

/***/ }),

/***/ "8cT/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8iO5":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkYAAACOCAMAAADjJzeuAAAArlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8tivQqAAAAOXRSTlMA4GAPoDBv0MCQUPFAr4D6BiAKEwIY5yw1qlYcyvXUvNyWSuulm1uMeGknh+M77cW0tyRk2EV9c/fqCRlaAAAcDklEQVR42uzcZ3OrOBiG4RdjcME2GHDvLYl7TXn+/x/b3SQnAYSEBCabndnr4xnPGRtuhCQc0//+98nfb+vnWd+l3DmdWm3j0L9Dfypr07M5IAlurfCw10mCT3lwu2axtNPOV4f+K/YlvFtcKVd+/2zjb/bxaUA/r9bGh4pDSdYL/M0+7UnMq+xgT4v7+xZ0nQ1tfLpt6Af5++trtUVpPNj4Y0Y56pbwxa4b9MP2Nv6o+yQ2wx8NEuku8M6+0l0050/LsY2Q9oB+it5YfByfCykzbHxbU24KNkKWrfsc+L1OMvSd/MfsS750cMAffcpEN/ovxdIIcU6kyqlWTuVTo0NqLjd8smqk6oyAhUs5WSPKytys+6IBsJcXSvaEgJ1PIjd8swSV9gIva1EanjFfb5fHBUQMUvOww4elTgo8DV8OTVLTQkiV8jFHjMmAsjA0fBj1KdENQR0S6CCoIHfoHkmKow8u3efq9XW7Og21N8h4IiUVfBmqdPSIgGK289ugXNRGiGNdKb2LhS+1xBcjZE4CVcj18YCANiXaTy2oUj8nVwSsSJq/QIDlkJICQiqUh6oNjvOAUvJL+Ka5JPaKkGcSMBE0I54VgpqSk0N1L8FZz6o8WfUd4nJCNdgtktVESPP3ZfRgg+tQpXT6CLqS2BAhGxLoIWhLPFME1RInh6rY6ft8inftK/E8I+SBZBkIMX5dRiaEVi4l6K63hSZFlBFUVrqnHXzi89sIMoljAJWMakjL9uhTI3qekmtt/FBGZt4Z+TMkGHdIpP8xO64PKEhHiO2QSAMhSxJ4lpxGPSCkQyKOhrSKsadq6VAsM21G3V+dkX5Gore1zFbgoiP41LgIU9YUpkZLhHjc16l0XEBa7RZ98EYIOrsU5zVtRrXfnNFlDBl1T2Ic0fTIcipor7AcHZNAy0ZQiTgcC0ETEuqlrsjgBIKyzj9e2TPa/KaM+hbkLPoSQ+2jIKNa0hZr8nzcq65fTLOOkKNpmoVqx0lKc01CR6RiB/b6J4gY6jlm1MyUUYPuyKlAXs+jGCcEWDo/IyNxP5Hdqh9c9EBEMxt8b/WqL1ruo0VCdag71NeD0AZq1ND7oYxqj6ey2BQhWvnTpM7Vq9RIxmYIFYt+4h57P11GxbhD6z0uANwa+mdSUyQYbvj7MxgmXq1qdr3XbqTbMRgl/Scy8ibIycSjROYIcexeW35AekDILFVGFxvslpzRxodd970KieQPHfpWjXlg4dQK1Q3F0heQZI97L9UWsZZxaev5Z+QfkZubTmIDTsIlg1xzwTtRVwrbgjeP7ctntASYBwTN77dgdSKPELhuDn2pszPS63uZtz7FqULC2IzMwhL/h4mbe0ZX5GhFIo5pIY69dT7mIeA4dkQLnBt9KUhnZCDsEp2vlnyiIWRceY8OhsGdiaKfdhe7qD5NPzvCjMzsGQ2RI7uZ+A011q2b9ArYFZ0/M9XUMnIGLnv0e+wW45wGEGJHw0dmnWYmXWLPOzBsWyGjjoUYyztlVOVk5CJXJvF4K8QruvTFadiIt7g6vIymKhnNJwDGL+u4F54iU645pFgUvxVoezQY8b9uw64FD9PhqfLaN5ySQkY0txHjkYIe752RgVz1uN8lsxAR/03TTgkc4zkno5J8Rs4Ssc4xj9jq0gspl4j8zXP3Mfof0KPMuu3SNYxOs6nTF6WM6HmEGK8UULlTRnrkZpcDwaHyrzvE23UpwtmCp7xXzWjD2XCKqsVcsj1qSGfkPO3AqBJNVXaReBmtKEF3gRjV/3BGZWI5D2OlLYL9FDynplpGTQpZi961e4jeFiqQE/9wZ+dQKxJruowqlOSigTUycsyog1yt2Iiu3CrsJ5/i6CvwWHMimqTMyGmLBqMrwqrSGW0WiPHE7D/Mc8hIsE26a+WXkWMjT/1oEeYO91UlKqfM6BmCmZF/iwSrS2ekIcbII5ohZJ9bRjQYg3V0csuIzshR26WgzWyEext1BBmZwoyeEK8bt3O5jRx8VTP2gZeeX0bkxXU042S0zp7RHDm6UkBtgjxMUmfUEAxGVELIWyt68MvbRuXDYx3JNsxu5JFk3dQzIu8GViE+owLJ6nMvhBVyM6Nv+hI56aTNqIBYnY/Ljv0oM94a1EOiOjujX5Msjc0o3fzorUPvZtIZGbOSFrBAyE7743a6WcjFYU3fWmPw2XVk8BTJ6CibkWdznzX4pZjt+CJ392aHJAazFLC9fDOi5g6MsUv/KMpmVIG8W6FgikVOVN1Mtp679E34bHxomMhgFnl35YSMEgbiTdxAVSRhRprMYNSK/lPOGVHnAMZKKaNXqNA8EmLvpaoEnby9OArRT8GoyGekU4i34zzGdNsIsS8ZM6qxM/p+2owaJGs/AqOvkJE+gpJV3hmNwVPeRCa7Ypd+GxHmMW1GZFhgFdn3MyOFjKxb7GjkTxG0cPLPiKpgHFryGRWgxm7lm5EHjkUhsgBIMCXSKzZCNqXUGZHRBmt7eUOIPVDK6BmsdfSUPlIuGSXfBU7yGc2g6CHfjJqIN/OSR092o8w4hi90fkZPSRnRoCSxfzgjpYziBle7NozEn1NGyXPkgnRGPSjaktAql9GobNAfL5AycSK/qgKMdUFGjcSMyK0jyagVk9FKkBFtwbA5y8mcM/IniLK8aEbV9H9ioDLEsvWqmoIxrdI3vwIJdZ35osnEo2wZkb+UvcaK3PXSIpIRrZOHfwVW+ozImyLqRTajIhRdc85oi4i26VCIUTneNJFSsUYB+rU3HC7nMRvOE7WMyC9CaKHHXZy7coDN/PrMA4TaTm4ZJX8dUqO6XEavUDTIOaPBG4IOTy7dCZtRXZiR+lTyVXGM1yi5oxeK5z5VYtgIGlai5iTSR1RHMqMN1JxIKaN+th8MWbzoRP9KRg6pd6Q5qTKidYqVcWeMVHqe0jS7L5kRLaHicFHLqErS2DO6M12ifymj5DUEq0/pMqJX5T/uqI6QktahCNEjhLVsRt4Q8hZ7yj8j2tdHQLtXdehDy6jJ6xqf9vuNQxHT7Bn5PXCUKW1GtFX8vc8q0rM+OtKNjk6MwSHlaESuWYKc9qxFeWTE8nWXPtWWbaRlT/o+BWnZMyLnhHhG+oxopTSH2IyQgaYTVY/vh+c5aXq0YTIScFrNb41wu80vOklYqmSUzDshm+NALqOKdEbklpNuP+oZ+XXE2lOcMzJpeGd8WrrCm3Yp+kmeU+6KW6SGqTcT74astNa9MyL9BpbVypIRuUPefZI1QDbtKb6MmxTm3vBtHv0kNZL19IsyOiG7yd0zossBjNcUw8WUvrU0sOZJ6/LsDtEBZtMO7r+f02bU+D0Z1XAPc25GxZQZUc1GxNihgDKklMSbfxgm3y+yswsU1hzinf3oE5Xvk9GOWEZxavHYCBlZPNqkMnckJlrZ1bNnlLzBUqOsGdEz0+b80m3dZ52mtMPp9+tTrfzSIrpbRhoxXnAv7VdxSAvcw8hXz8giIVdD2PHBfBhkzKjDZLQAUO5SlGfjvmbEkWNGJu5oOCA+D/exoT/ad8poizhFTz2j5AmVXU3aVclu6f90RgMb97QTdLRBNuwEzbpPRl0bsW6tDBnVwPFmUERrgQx2yR3ln1EF93X0icfAfRQkMlopZOSMwTF0Yg5++y/uznRLTSUIwKWIIC4ICO6Au+M2OhNnrPd/sZuTm4zebnoFYnK/fzknmYz0Z9NdXVVtPcDW6JX9iBhX7+ixn2MGw56URseiNDpgwaxL16guoVFNQaO98L+ymRdPMTWaI5srkFybqIf7ApBgBjUpjcyCNAqxaCZ/m0YtJKCbG9usunefpVHP4u41Kfop6vBtwCq3xkaxGjW4Gg2wcEJZjdJhTYZhKqvRSkej4CBW1mJpZLDeVmvk8QYUvvedvvlIBQlWJolPHMcLM5usYjRKqaEtnKukRluQpS2pUUNHowsSTIhkRbFG9FlHl1R/SraiE3OUXzB0V5jBujyNLOo8p3CqhV+Cs8+t0QFYfCBB4xMfedHSqI4E75HyZx/yzRCHbdxW6RrRKTvla9TS/gi5NapIlwVWfBMfiXU0CpvU5qxD9C4RMnZRxSNnyklKLF+jLRbNqCyNaE8xr0bmlH4ld6f4SEtDoxrdOMlPFXfaDW7QjOa4QIrYL00jOpGgYFqSGtUdWc7qGi2lNHqLkGBFSTAkH/4Lc6Nrs/Z+M+oc3wYB4Q0zcefAoJ/h0bA8jeiuk8UyLv6AX12jtoxG45R+pVED7oYcjUzCjey93yKgR7AlXA8ymLaYHkVI8cnX6K0wjcDYL7BAFvC3aOSlSGKvasuzRe0oLda9iY0sjdqZC5qgozIdBVNk0TQBZCdXdAdcjTyQZcWMkPXuD9SUYtCiuM6Q4Px3aOQPRhFKEZO989zKL5oZGXX+BglutaEdN5GgJQgas1kw5xCzmZWp/cg3XY1qmRoZHzGiVX0oRa1dli8GKPNGTaPP06gjrdH1gvKYUJHOhOovb+pZnDRhEzmkIbuvkWB5VClGI/veGPbhJLj38e+fT+v8GY27P1GjlLxtW4WNvEYfLkozADYz5GL5Cn2N1iVpNE8eHhFRq7XNW6NvAZP58zSy8iTqHXqyGm0KKljui2y89Nip9ySncRkaDRKq+2qHcFeBcIrSXVadogNTvp5G4Q3VaKUoRYRKmDlKH2ac8SY5F69RvCQTnIhbMqc7yNOMqemXphEdgTP0NHpHRWYWlkEtz9u/zim4JqkWrRHNtAsbMlVLHs+lviV/hkYJR6MVKhJdsAzcMUMEK9cJuHei011YGoVFaYR9sDj911RrPXZ/iEY2R6M2qmJjKezzNBc6vcmvQd9ZGhmaI01zhBPqZlYe6dfwX6DRBlWJsTDEPWnHTZQiZjqwYefJHXQ1aiMfDyI6YkUiO/u2FDR6qcpiSWq0ldNojqpEByyFda6K/jYw8GNk3eXcLEmjOCP5fKjbNHcCPBztjyCpUV1Oo14FVdmrXoOlH4JcowhxpNd0id+sdI3WAB3Ou1Qt1OoAj9HzNLJzvl3rDRTybRzpVG7SHYmkcY+S0aMkr0bBdiG8WXjHuO9GOT0v7gGPqrZGjCL+QFMj2KOAZrNJLIa3N+RzDjR6OgRAkqgs0Q6B3HKjnk+jluiEZ9klhomV7yQ1+46gHI2GjAWYp6sRvJ/uM8LBSoarzUe9OroezTcvMP4diAORHh9+TKbsAZ4NfvxYFzmc0kkytPjPoI4cjhblrlTC8inIodGukyKfW/3ncEyFoTGa8ERPRqVo5F8X6hq98jUCvzobDmed0a4LDBoZE2DX+M7jSHcMwwi94OuH9Ie3+9ONYrtda3Q+30fzY98zMsa3wqvfpTG9BcoeGmyIv6SnUVifoAh7x7kIuqreq2gEIo10UdfIEmikNtl+e5Qt5Xa59geO0zqab2MfsjlxAkdGKjg9uSIB89Chm9AhYVoj4BFUExQSrbmVwjcTuNDmWb3/lUb+4f4sjnCnrxBjE+znD4bgq9kkNYIPRn04jb/8+ct/9nQ0OjYsFHPbG/DA2xRJ0gA4mLeM6Pz/SqN7YX3UYu83q6DK8S7JQJSrtqU06tl0VSOL+TlaTDohPOLKaTSPUQJ3FYoD8Gcg4M++CfwujQYsjaqFagTmjyGztgbnU9RBmV9uTHai5n0rupaGDgi4fVAAZTTqNVCG4Rv9L1+RoqNSiuf2f5tGnrpGF9Bi3BoEQJBbIxiliG6y7omKnaKA0KifuUGeFK5RQ0qizAH3pgoVZ5+CBJhSexyeQF2jNhRGndBIh9Dz6QGI6MgwoZGXHU8+FqzRFYW4lESc3drUlL+BMihdI/pl23++RlUQoN/r+QKURtmHB5ucGo2dbe314C6qzAioSjzowmxCTc++Wscn9aJzaM1cGnmjqg5LfGRVVWTtOPMQKIwJEjTHDI2od4Gtr9FuvUnusahkDN/x3VwajRdI8eoDRXjgNBArX6NKV0ajikij1gSfx2tLfFPAGhgaUd3hYk2NaKKBZG/FmmI+ULsHBIaFnPV1+Rq1oAiNtvhctv+1KMmuC7pmagSO/hob+TQH+TWCmUTTLv8VaTrwuzRy11CERmt8NiPaIvrQ1WFsUSf0mIrxzVFnKXGPjZ9XIz8W5o53L0hjdX+XRpMBcDQayWrUjfDZRD7v7jL3CDyN5mp3JY6vL42kglJ0ACZIk54U9uX9G9JURbePuaZWSduiokacbI78VnGOrEZzfD5fgx/GjIQ0tkYQ4520y5uAPpbWFBVIs6bq9pXYszQUTspo27ttzOBTL21oAOroalQjW6w9n18j0X1lp8c6rOwkR5Ar6Pedz1lSQQ18Ys/uXt5DADWNYMnrK++fOZmgYmLyoeRloKtRB5/Phb3Yjw1h2vHqHjWi/FnZB9QnADDsr6FvjwwAUNbIj9ke+QlmEIUgR88lunrmpiWv0Z+2wv4afv+EJAsPWBrRd7/Per/eX85W1x/qEvhuPUVE1343AEBHI+hPWSUMwStmcdXsPWKVqlHE1Sh08ekMWJepuS2pIgjHdjGd9QHGc2r+yW83hOY9o09DIxgxan13KffWJTFORmBkXN3UFGgPZ9VASqMmVyNY4bNpM49B15K1ND8Eqk2aWCSnEAhUNBJXAy5PjKchzZ7aWZoXVOe26bI0mktrFKT4XNKAlStRl0s77lYvTSweBxhUVDXqKQxu7IM0F3L/t3VRi1ef0aLLlNYIPAufiR2yauP3IKVRP8YyWIOcRhtgoPVVjTyQJyJOBTt5W3GQrYddX14j6L7bN3wOzbPDPJWZgZRG3gJL4DQHSY06IMHuhFJMByCPRzbmRX3MzDfCGQiNRFHXniFJsEcx7j4wpODEvmbA08gXV7Ppc7OWYyhUI2i5qpcHK5e1xXEBobsjuWfk9e/XJzijFNYA1JkQFnE0IhKtCsJNz42XK61Qfo2gqnerg8K5b4Q5iLN2XEMoSaP5AWWZGaDK9T6edZDUqI7FcBt+OESlXl6NlOO8dVAixuJwu/TpzMQoRyNjhQpEa1DlV2Nl2wRZjTZYDBUg0ddIM617C0qEWCRfU3Dv86cwMx8eQW2N6EFWgbZBjF+tJZf9AEBaoz1qcbKXxKxeukawFFuUY2nkTgu6/BqM9SoZbj2AMjTqJ6hObQwF8VLUS236T3tnutwmDATgNRhfYMBcBt/xhY84vo99/xdrx01rV4CEhHHcTL9fmckkE6wvWq0kdjvF87AN0BA+SfAENTI34hGNbWUZM7EDkjw0cicoRFe3IDtRXaLrKTZGLzjVdg78YiGskSqoEZgd4dV1FIfY6JhgJtwnaCQvxWdMb27mqZFsYAoKm+VUMeEe5UEanR+ytKxmvtMhYRYMh1OjEHixdRWz8C6ZeWnErn02qlT3KxkIsmkkFIycvUdNbK2Mxfwb5KdeuVJOYP2RrucnpX4/F27yTPR39r98xyQGkvlYjdRIVb4oH+tJ6ejCla/XaFVGOj0fuBiQmSbnUmtH/HiuGjWLRmK00op4jy9PUFgkcY1gFjMDvZW0T4FeQ6NdkGbr3+QZmMipGN7z4QCL0bM0cmqU7GztQpE8ljkWKKHtLOej0f259nu/OtdsuPI6GrUnBhJknpD0yBKd9jjZNbJENXJnBUxGdyCqEVhLygemhu1cNIJd2Bn0tqHky+K31zu5aeRWLzls/ZNj03Z4NVK5NJKFNHKGdYOW+awA4jQCaK5p8/bYB0HOhEYUhDSq5KRR4+2CHHiS2G3XMsi8GnVz10gJPaRRlCFGo1tNUgqdvQUi6K+jEcdatjk2kJOKL9K3RCc7j3M+xuDhGu1mZUYCPwSgaAT2BGmo1eYraKQ9SKM5ZUbvowjjBrCwyOzZz6hRmVsjhkMdZDCRga4RgLJGKhXJ+jYaSRCPXBqgIJdQ5jsaQg+erdEZElmcOuxsYpV0qqPAHa0CUumOj04GjbxX12hV7LJW03XajK3LXHdE3h6pkbtatSkaUWO5qS17yKQ7MxPf/W3CPdaJ9Tl6oSKsUeGlNXLPhzTX+qaqqEgaEqwya0QcwQ9ChV8jVwpUTAFxt7RObY/osndLDrry7TSyplvmc6ul61Tc7iMK7Y/UI5elHqaR1v3zK1om3LBZGvl6B1OxXgFQNSJZBMhkEPrfSCNzGHSRhVG14ZO9igL7IzvS02VEowO/RtGGE95ykXY2kgqYjkENgKFRFH+LbN7fjl+v0Sa7RlZrrCKb+gJutOuMZGRqQoRJtC0pQPtvA11gYMVqFJLBd9aEK02qRkVMx/vcBA6NeCsCdhbAIMxZozqkxYrVyJI2l1RPqnHeKR2F5GfTNuLqRDbIYogmUJFiNTpghFEwa9XmPVqHlhPnnSG2RlGGaUQaNYFO9dEaDXk0sobn0953fn1tRDUyzx+YhnINItgTZFDZy9RL3VNSoytqgULPi69Y6mFKWtx1IAZ7E4BDowjHCjIpm0/WqMah0d775fp47tsge5F3tN01pqHXErxEgpegZv7RLlJ73gQiqPFTIY7qmGicjaXLLROAT6MoWh9Z1F5Xo5Dxd8u9dBI5kIBZUtnz9cxMuH2uR9bA4hqtkUl0tANkUdcgmT5FIxJ/g3SKPBqVn6mRxNJ/jGzWQ6DhpvgdByX2NeGLS7QVE2HN+aKNSnhAX93R1ahwlYxb0M+6O6+qkTxidN1fIJPtClisOsiieyTuCV2pxoyGcMdoRaTD9IYqKJFrsjSSgYV98ijB81U1mrMq+81Yo/+2gDRM35keLaINvAyXI11ix4K6QDHzanKCv9wBAVsjNqbUo0Tnr9QogCQCeqRhxbTC2YaUWHo3xRLGSyjtscAMzIkGFVyvtfkJga94dACENGKjBQbGMQYqbzlrVKSsAGmE9H/gbc0BDtyqgVSapNaXNhFbxGjfnFDTxTRGVOvecksBjcRv586BSvFLNGKPjkIpe/iuN4CXRpE1a2hJ936aBooSwA1lgEw0eo+dj+KQcEhAIzbOMDI2H/KTNZIIjcTS/W3i4smoDx0QoVmndw6ASVJ/3RIKov6lu7W8MK0jaHp3Y7NcEQ8urBGb9uxAtA/j0ajzRI1WSEA2GrIvGGE9t0EYJaAubc3btw8u8QqkEN0jmQsR8YLde9l+6/7aoJXaQIO9agBeVpNbGA75ztS2OWgkEtVKsTnS4dSAbDQDajm237uVATmerRHyc/Dj4kVgJMbqHcRg+rVaE0SoZo0z1rRvXPWeco76EjIzJa4GQyJ2j1E526nfD8rShwewmFwwimrBFXtf3G6WCkSQTwXko5N01GXP+/E/0IDH4hPTrQjWT4kVB6hET5KUBx7NssW0x/ER7QyfOPrnmPf0JjwKd/khVHp9MZ3p8Syrf7OczTUZKLhSnczbRiUThGFvqRwsyJcSsTmQFZuneOfiFC3W2783xpbCqj5twEOx5gNiIjDh2Th+adz7Hd+8YGrC45HX+ElhAXlzvvyx6CHK1pFooUXH0mbBwcBPDlUFhBFNacs2fA2O62tDzbchJ8yTep3eJzbkT1uveF21V9TgITRGZHMSNk57dazVhr4MT6MR/o5tEwu+LebxPKvJ8C+iDO6Kqb8w5jHcVIJZA/7zklizq0he6MJ//pOBxnG4gH+JH+RFyJTVGn96AAAAAElFTkSuQmCC"

/***/ }),

/***/ "9TKQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopModal_vue__ = __webpack_require__("uW3H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691da9a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopModal_vue__ = __webpack_require__("UjgU");
function injectStyle (ssrContext) {
  __webpack_require__("aeJD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-691da9a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PopModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_691da9a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PopModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Acex":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAZlBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKyso+iKtBAAAAIXRSTlMA+NcjFWx3aKDIkAXMs6mGg31JOC0nGe/iv7WwmHNaVw4H50OtAAAAnklEQVQ4y82Q1xKDIBQFFUMRa2zp5fz/T2a8ZhTMxcck+3Zmd2Ag+joqrzd9CaDIgnrIMSKSgG8PmIgb1mssSMZbuFzXOjvD5/T0fC+w5tg5vonB8Jj9DTz7tzcIUdKfpQgj6P1Sq5i9Qcv5P9ggWtixQfKboDDGXDYCS6sOB5rWPRwoWvIzGNigd07AREVL+ScQlRhJWxpdSstGf8MLd38zG1/3VJwAAAAASUVORK5CYII="

/***/ }),

/***/ "AjwE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B2vO":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAeFBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysp4iEYnAAAAJ3RSTlMA2+z7DAT349+0lBIJznI+OTXx5seZa0ow1aidj4Z8W1EsJyIOv3/todc9AAAA2klEQVQ4y83SRw7DIBAFUKqxMS5x4pLe8+9/w7CIFMDWLKP8HczToBnBfphyHJXrgV67urA3xnRcVzshXncOCNVI4Mguu+MUglUGPK8VwNUZwOG+BYoQtMJfXDceuIsHp8afTdRB+JpdA11Te2CHzp8T8Ak3AISRCZgEkoTAtVNDgXZv8npNgBwACQBkRUeAAoAEAcYMAAXUngKfPdNAHxZB/t3jjZMdfE4LU8g+AGW18MKKBRmyWYNBh0DbREjrkk95NhHYliyJ3kSgeqRAJWDW4cHjGUr2N3kDhpFC3IQXha4AAAAASUVORK5CYII="

/***/ }),

/***/ "BZwE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D8HT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DMBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isAnimateChangeLanguageOn: false,
            isAnimateListOn: false,
            managementLanguages: ['經營理念', '经营理念', 'MANAGEMENT PHILOSOPHY'],
            managements: [{
                imagePath: __webpack_require__("Sz2z"),
                title: ['企業願景', '企业愿景', 'Corporate Vision'],
                description: ['不斷創新，開發具獨特性的遊戲軟體，以業界優良品牌為目標，追求卓越進步，跳出以往的框架桎梏，突破創新並帶給客戶端不同的用戶體驗。', '不断创新，开发具独特性的游戏软件，以业界优良品牌为目标，追求卓越进步，跳出以往的框架桎梏，突破创新并带给客户端不同的用户体验。', 'Continuous innovation in technology and develop unique gaming software. With a goal to build a reputation in this industry, we strive hard for excellence and constant improvement, jump out of the circle and give our customers an experience they never had before.']

            }, {
                imagePath: __webpack_require__("Z9UQ"),
                title: ['優質的團隊合作', '优质的团队合作', 'Excellent Team Work'],
                description: ['公司研發部門同仁擁有專業技術及有品質服務，在透過團隊合作及相互學習同時，亦獲得更大成就及革新的成長動力。', '公司研发部门同仁拥有专业技术及有质量服务，在透过团队合作及相互学习同时，亦获得更大成就及革新的成长动力。', 'Our professional research and  development department provides specialized skills and quality service. Working and learning with each other enables us to achieve greater goals.']
            }, {
                imagePath: __webpack_require__("dhCe"),
                title: ['追求卓越', '追求卓越', 'Pursue the Highest Quality'],
                description: ['善於吸收過往經驗，不斷探索、優化、創新，經過慎密的思維討論，傳統遊戲領域全面佈局的同時，突破創新技術，獲得改善與增加市場競爭力。樂於接受意見與改進，為公司全體同仁職涯發展帶來新契機與滿足，達到企業組織的整體目標。', '善于吸收过往经验，不断探索、优化、创新，经过慎密的思维讨论，传统游戏领域全面布局的同时，突破创新技术，获得改善与增加市场竞争力。乐于接受意见与改进，为公司全体同仁职涯发展带来新契机与满足，达到企业组织的整体目标。', 'We learn from our experiences, break through technological innovation to improve products and build up market competence. We take delight in hearing different opinions and improve ourselves in order to meet achieve the goals of the company.']
            }, {
                imagePath: __webpack_require__("4D7g"),
                title: ['致力目標', '致力目标', 'Essential Aim'],
                description: ['不斷創造最佳價值是創樂的致力目標。縝密規劃、積極卓越的創新技術服務行動，因應瞬息萬變的科技產業特性。', '不断创造最佳价值是创乐的致力目标。缜密规划、积极卓越的创新技术服务行动，因应瞬息万变的科技产业特性。', 'Continuously create the best value  is our aim. Deliberate planning and outstanding technical service to adapt to the constantly changing industry.']
            }],
            selectedLanguage: 0
        };
    },

    methods: {
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            setTimeout(function () {
                _this.isAnimateChangeLanguageOn = false;
            }, 1);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
        });
        this.$root.$off('animageChangeLanguage', function (e) {
            _this.startChangeLangAnimation();
        });
        window.addEventListener('resize', function (e) {
            var h = document.getElementById('chuangManagement').offsetHeight;
            _this.$root.$emit('updateMngSize', h);
        });
        window.addEventListener('load', function (e) {
            var h = document.getElementById('chuangManagement').offsetHeight;
            _this.$root.$emit('updateMngSize', h);
        });
    },
    created: function created() {
        //console.log(this.folderName);
    }
});

/***/ }),

/***/ "DWVv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('ChuangHeader'),_vm._v(" "),_c('ChuangIntroduction'),_vm._v(" "),_c('ChuangManagement'),_vm._v(" "),_c('ChuangCompetitive'),_vm._v(" "),_c('ChuangCore'),_vm._v(" "),_c('ChuangPersonnel'),_vm._v(" "),_c('ChuangFooter'),_vm._v(" "),_c('PopModal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DkvJ":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAiBAMAAAAuQN21AAAALVBMVEUAAAD///////////////////////////////////////////////////////+hSKubAAAADnRSTlMAiCIz9fLVgB35lGtnGCiR2nEAAABmSURBVCjPY+Dxe4cGfBgYWN6hg6cMDHzvMAAOQU4MsZcMDFwYgq8YGBiUjdGAAsMAA45CQTRQwcDAhuH4Z1j9TrwgVjOx2z7Q4JISGrjAwMCI4fiH2OL9CfEBgiPVccehC0ZjdyUAdCwlxthRuPoAAAAASUVORK5CYII="

/***/ }),

/***/ "I2rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangCompetitive_vue__ = __webpack_require__("wctT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc21aaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangCompetitive_vue__ = __webpack_require__("jjyy");
function injectStyle (ssrContext) {
  __webpack_require__("R0ox")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bc21aaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangCompetitive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bc21aaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangCompetitive_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KNZ0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-pc.a6333fe.png";

/***/ }),

/***/ "KRWg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chuangManagement"}},[_c('div',{class:{}},[_c('h5',{attrs:{"id":"chuang-management-title"}},[_vm._v(_vm._s(_vm.managementLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_c('div',{staticClass:"row overwrite-row "},_vm._l((_vm.managements),function(item){return _c('div',{key:item.id,staticClass:" chuang-management-list-container col s12 m12 l3 xl3"},[_c('div',{staticClass:"chuang-management-list-image"},[_c('img',{attrs:{"src":item.imagePath,"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"chuang-management-list-title"},[_c('h5',[_vm._v(_vm._s(item.title[_vm.selectedLanguage]))])]),_vm._v(" "),_c('div',{staticClass:"chuang-management-list-description"},[_c('p',[_vm._v(_vm._s(item.description[_vm.selectedLanguage]))])])])}))]),_vm._v(" "),_c('div',{attrs:{"id":"competitiveLink"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KXKi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-bg.04f2eb6.png";

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d72f7c64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("DWVv");
function injectStyle (ssrContext) {
  __webpack_require__("xztD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d72f7c64_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N81f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"footerBgContainer",attrs:{"id":"chuangFooter"}},[_c('div',{staticClass:"row overwrite-row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col s12 m7 l7 xl7"},[_c('div',{staticClass:"footer-info"},[_c('p',{domProps:{"textContent":_vm._s(_vm.footerLanguages[_vm.selectedLanguage].address)}}),_vm._v(" "),_c('div',{staticClass:"row contact-info"},[_c('div',{staticClass:"col s12 m12 l4 vl4"},[_c('p',{domProps:{"textContent":_vm._s(_vm.footerLanguages[_vm.selectedLanguage].tel)}})]),_vm._v(" "),_c('div',{staticClass:"col s12 m12 l10 vl10"},[_c('p',{domProps:{"textContent":_vm._s(_vm.footerLanguages[_vm.selectedLanguage].fax)}})])]),_vm._v(" "),_c('p',[_vm._v("© 2017 Copyright Chuangle co.ltd")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m5 l5 xl5"},[_c('div',{staticClass:"hide-on-small-only footer-logo clearfix"},[_c('img',{staticClass:"right",attrs:{"src":__webpack_require__("KNZ0"),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"hide-on-med-and-up footer-logo clearfix"},[_c('img',{staticClass:"right",attrs:{"src":__webpack_require__("KNZ0"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__my_global_js__ = __webpack_require__("2eql");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__webpack_require__("X0eL");
__webpack_require__("0lrd");
__webpack_require__("oPmM");
__webpack_require__("llnD");
// require('./assets/js/responsive.js')
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.folderName = 'ali';

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "NqDs":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAdVBMVEUAAADKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysrKysqS6/YwAAAAJnRSTlMAthD1mPrwpTwD5eDYzcSNaEoqrTUW6ZIfB9zavpx0RS6AYVxZVCIzt1QAAAD/SURBVDjLjZPZcoMwDABlbHMTO4QzzdVL//+JHcsUTYpdsm/AzggtGJgigf94CI3pNe7kEh2nqCCQ0FGh8oKMCpkXxqgwkyEK8ASWs074gC0t6rSqmzM6SmNUJi5NfWahwxAVC3lQOOwJgoVjUMj2hOvTCF1uBOUe+QCTbHqYDsgsH+17wPRGnqvXp89C2XZ05wt+OeHOuiospACFzZ3QhAVNa1qYDYZ58x1KvS2l6B98j6WuAR4lopgB2ujbJ8eOMqzj1Mi5GmDk0s71+uQRTI1ESxfDIsjtiZho3rpOAn8bGpYdHQu3NSodH89wZ6G36lJJOdIvroTIjL338Do/rc5Jk6ZqVb4AAAAASUVORK5CYII="

/***/ }),

/***/ "OaoU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-bg-mobile.620f440.png";

/***/ }),

/***/ "OjsS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-eng-pc-bg.db5d457.png";

/***/ }),

/***/ "Q2GU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"coreBg",attrs:{"id":"chuangCore"}},[_c('div',{class:{'row overwrite-row':true}},[_c('div',{staticClass:"col s12 m12 l5 xl5"},[_c('div',{staticClass:"core-container-description"},[_c('h5',[_vm._v(_vm._s(_vm.coreTitleLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.coreDescriptionLanguages[_vm.selectedLanguage]))])])]),_vm._v(" "),_c('div',{staticClass:"col s12 m12 l7 xl7"},[_c('div',{staticClass:"core-container-illustration"},[_c('img',{attrs:{"src":_vm.selectedCoreImg[_vm.selectedLanguage],"alt":""}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"personnelLink"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R0ox":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sz2z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/management-01.20581da.png";

/***/ }),

/***/ "UjgU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isModalShow)?_c('div',{staticClass:"invisible-div",on:{"click":function($event){_vm.isModalShow = false, _vm.closeLanguageSelection()}}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VvWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangPersonnel_vue__ = __webpack_require__("kJt9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb66880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangPersonnel_vue__ = __webpack_require__("mlNN");
function injectStyle (ssrContext) {
  __webpack_require__("8cT/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bb66880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangPersonnel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb66880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangPersonnel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wf7Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X0eL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X9iX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-eng-mb-bg.7b90689.png";

/***/ }),

/***/ "XJGK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangIntroduction_vue__ = __webpack_require__("il58");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9b74cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangIntroduction_vue__ = __webpack_require__("r8AK");
function injectStyle (ssrContext) {
  __webpack_require__("BZwE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9b74cac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangIntroduction_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9b74cac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangIntroduction_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YPNJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangHeader_vue__ = __webpack_require__("//2Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f5a66c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangHeader_vue__ = __webpack_require__("uFD5");
function injectStyle (ssrContext) {
  __webpack_require__("w9y7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8f5a66c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8f5a66c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yqm0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangCore_vue__ = __webpack_require__("463W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a4deaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangCore_vue__ = __webpack_require__("Q2GU");
function injectStyle (ssrContext) {
  __webpack_require__("AjwE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10a4deaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangCore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10a4deaf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangCore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z9UQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/management-02.581fabd.png";

/***/ }),

/***/ "aeJD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "atO3":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/personnel-bg.04936cb.png";

/***/ }),

/***/ "bk44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangManagement_vue__ = __webpack_require__("DMBx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a82db53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangManagement_vue__ = __webpack_require__("KRWg");
function injectStyle (ssrContext) {
  __webpack_require__("D8HT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a82db53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a82db53_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cQAS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footer-bg-mobile.d731e2a.png";

/***/ }),

/***/ "czt7":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/intro-bg-ch.7225fa1.png";

/***/ }),

/***/ "dhCe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/management-03.2d08867.png";

/***/ }),

/***/ "dvsa":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/footer-bg.b8cf7c7.png";

/***/ }),

/***/ "fzuy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-illustration-eng.4fab6fd.png";

/***/ }),

/***/ "hdX9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-trad-mb-bg.8a81057.png";

/***/ }),

/***/ "iDkQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangFooter_vue__ = __webpack_require__("kPgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1bf2eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangFooter_vue__ = __webpack_require__("N81f");
function injectStyle (ssrContext) {
  __webpack_require__("Wf7Y")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d1bf2eaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChuangFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d1bf2eaa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChuangFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "icQU":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/introduction-bg-pc.663b179.png";

/***/ }),

/***/ "il58":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            introGotFocus: false,
            isAnimateChangeLanguageOn: false,
            languageToDisplay: [],
            res: 0,
            introTitleLanguages: ['Hello, we design mobile  &amp <br> web interfaces that are simple to use.', 'Hello, we design mobile  &amp <br> web interfaces that are simple to use.', 'Hello, we design mobile  &amp <br> web interfaces that are simple to use.'],
            descriptionLanguages: [['創樂科技有限公司剛於2017年6月成立，為香港在台灣投資的遊戲軟體公司。我們擁有良好的研究開發及技術支援，目前以研製手遊為主，且在台灣、香港、中國、菲律賓、馬來西亞等地已有公司。正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，並規畫著未來進軍歐美市場。期待能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。', '创乐科技有限公司刚于2017年6月成立，为香港在台湾投资的游戏软件公司。我们拥有良好的研究开发及技术支援，目前以研制手游为主，且在台湾、香港、中国、菲律宾、马来西亚等地已有公司。正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，并规画着未来进军欧美市场。期待能打造原创游戏品牌，在台湾与海外市场占有一席之地。', 'Founded in June 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.We have a promising gaming software technology development and supporting  team. As of now, we mainly develop online games, and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. One of our goals in to have a market in Europe and America in the near future.We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.'], ['創樂科技有限公司剛於2017年6月成立， 為香港在台灣投資的遊戲軟體公司。<br>我們擁有良好的研究開發及技術支援， 目前以研製手遊為主，<br>且在台灣、香港、中國、菲律賓、 馬來西亞等地已有公司。 <br>正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓展，並規畫著未來進軍歐美市場。 <br>期待能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。', '创乐科技有限公司刚于2017年6月成立， 为香港在台湾投资的游戏软件公司。<br>我们拥有良好的研究开发及技术支援， 目前以研制手游为主，<br>且在台湾、香港、中国、菲律宾、 马来西亚等地已有公司。 <br>正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓展，并规画着未来进军欧美市场。 <br>期待能打造原创游戏品牌，在台湾与海外市场占有一席之地。', 'Founded in June 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.<br>We have a promising gaming software technology development and supporting team. <br> As of now, we mainly develop online games, <br> and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on. <br>We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries.<br> One of our goals in to have a market in Europe and America in the near future. <br>We are looking forward to develop original and unique game brand, and make a name in Taiwan locally and abroad.']],
            // descriptionLanguages: 
            // [
            //     [
            //     '創樂科技有限公司剛於今年成立， 為香港<br>在台灣投資的遊戲軟體公司。我們擁有良好<br>的戲軟體技術研究開發及技術支援， 目前<br>已研製手遊為主，且在台灣、香港、中國、<br>菲律賓、 馬來西亞等地已有公司。正陸續<br>朝向日本、韓國、泰國等東南亞國家市場持<br>續拓建，我們也規畫著未來進軍歐美市場。 <br> 期待未來能打造原創遊戲品牌，在台灣與海<br>外市場佔有一席之地。',
            //     '创乐科技有限公司刚于今年成立， 为香港<br>在台湾投资的游戏软件公司。我们拥有良好<br>的戏软件技术研究开发及技术支援， 目前<br>已研制手游为主，且在台湾、香港、中国、<br>菲律宾、 马来西亚等地已有公司。正陆续<br>朝向日本、韩国、泰国等东南亚国家市场持<br>续拓建，我们也规画着未来进军欧美市场。<br> 期待未来能打造原创游戏品牌，在台湾与海<br>外市场占有一席之地。',
            //     'Founded in 2017, Chuangle Co. Ltd., is a<br> Hong Kong funded gaming software <br>company in Taiwan. We have a promising<br> gaming software technology development and supporting  team.<br> As of now, we mainly develop online<br> games, and have established companies<br> in several places such as Taiwan, Hong<br> Kong, China, Philippines, Malaysia and <br>so on.We are expanding our market in <br>Japan, South Korea, Thailand and other<br> ASEAN countries. One of our goals is to <br>have a market in Europe and America in <br>the near future.We are looking forward <br>to develop original and unique game<br> brand, and make a name in Taiwan locally and abroad.'
            //     ],
            //     [
            //     '創樂科技有限公司剛於今年成立， 為香港在台灣投資的遊戲軟體公司。<br> 我們擁有良好的戲軟體技術研究開發及技術支援， 目前已研製手遊為主，<br> 且在台灣、香港、中國、菲律賓、 馬來西亞等地已有公司。 <br> 正陸續朝向日本、韓國、泰國等東南亞國家市場持續拓建，我們也規畫著未來進軍歐美市場。 <br> 期待未來能打造原創遊戲品牌，在台灣與海外市場佔有一席之地。',
            //     '创乐科技有限公司刚于今年成立， 为香港在台湾投资的游戏软件公司。<br>我们拥有良好的戏软件技术研究开发及技术支援， 目前已研制手游为主，<br>且在台湾、香港、中国、菲律宾、 马来西亚等地已有公司。<br> 正陆续朝向日本、韩国、泰国等东南亚国家市场持续拓建，我们也规画着未来进军欧美市场。<br> 期待未来能打造原创游戏品牌，在台湾与海外市场占有一席之地。',
            //     'Founded in 2017, Chuangle Co. Ltd., is a Hong Kong funded gaming software company in Taiwan.<br>We have a promising gaming software technology development and supporting  team.<br> As of now, we mainly develop online games,<br> and have established companies in several places such as Taiwan, Hong Kong, China, Philippines, Malaysia and so on.<br>We are expanding our market in Japan, South Korea, Thailand and other ASEAN countries. <br>One of our goals in to have a market in Europe and America in the near future.<br>We are looking forward to develop original and unique game brand, <br>and make a name in Taiwan locally and abroad.'
            //     ],

            // ],
            clientWidth: 0,
            selectedLanguage: 0
        };
    },

    methods: {
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            _this.selectedLanguage = parseInt(e);
        },
        changeIntroBackground: function changeIntroBackground() {
            if (this.clientWidth <= 900 && this.selectedLanguage == 2) {
                this.$refs.introBgContainer.style.backgroundImage = "url(" + __webpack_require__("xSxi") + ")";
            } else if (this.clientWidth <= 900 && this.selectedLanguage != 2) {
                this.$refs.introBgContainer.style.backgroundImage = "url(" + __webpack_require__("czt7") + ")";
            } else if (this.clientWidth > 900) {
                this.$refs.introBgContainer.style.backgroundImage = "url(" + __webpack_require__("icQU") + ")";
            }
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
            _this.changeIntroBackground();
        });

        window.addEventListener('resize', function (e) {
            var h = document.getElementById('chuangIntroduction').offsetHeight;
            _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
            _this.$root.$emit('updateIntroSize', h);
            _this.changeIntroBackground();
            if (_this.clientWidth <= 990) {
                _this.languageToDisplay = _this.descriptionLanguages[0];
            } else {
                _this.languageToDisplay = _this.descriptionLanguages[1];
            }
        });
        window.addEventListener('load', function (e) {
            var h = document.getElementById('chuangIntroduction').offsetHeight;
            _this.clientWidth = document.getElementById('chuangIntroduction').clientWidth;
            _this.$root.$emit('updateIntroSize', h);
            _this.changeIntroBackground();
            if (_this.clientWidth <= 990) {
                _this.languageToDisplay = _this.descriptionLanguages[0];
            } else {
                _this.languageToDisplay = _this.descriptionLanguages[1];
            }
            _this.res = window.screen.width;
        });
    }
});

/***/ }),

/***/ "jjyy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chuangCompetative"}},[_c('div',{staticClass:"row overwrite-row competative-bg clearfix hide-on-med-and-down"},[_c('div',{staticClass:"competative-container-lists col m6 l6 xl6 offset-m6 offset-l6 offset-xl6"},[_c('ol',{class:{}},[_c('h5',[_vm._v(_vm._s(_vm.competativeTitleLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_vm._l((_vm.competativeLists[_vm.selectedLanguage]),function(item){return _c('li',[_vm._v(_vm._s(item))])})],2)]),_vm._v(" "),_c('div',{attrs:{"id":"coreLink"}})]),_vm._v(" "),_c('div',{staticClass:"row overwrite-row competative-bg-mobile clearfix hide-on-large-only"},[_c('div',{class:{'competative-container-lists col s12 m12 l6 xl6': true, 
                                                    'english-layout': _vm.selectedLanguage == 2}},[_c('div',{staticClass:"competitive-mobile-list-container"},[_c('ol',[_c('h5',[_vm._v(_vm._s(_vm.competativeTitleLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_vm._l((_vm.competativeLists[_vm.selectedLanguage]),function(item){return _c('li',[_vm._v(_vm._s(item))])})],2)])])]),_vm._v(" "),_c('div',{attrs:{"id":"coreLinks"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kJt9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isAnimateChangeLanguageOn: false,
            personnelLanguages: ['招聘人才', '招聘人才', 'PERSONNEL RECRUITMENT'],
            personnelRecruitmentLists1: [['DBA(SQL Server)資料庫管理員', 'Android資深工程師', 'iOS資深工程師', '資深C++軟體工程師', 'WEB前端工程師'], ['DBA(SQL Server)数据库管理员 ', 'Android资深工程师', 'iOS资深工程师', '资深C++软件工程师 ', 'WEB前端工程师'], ['Database Analyst (SQL Server)', 'Android Senior Engineer', 'iOS Senior Engineer', 'C++ Software Engineer', 'Web Front End Engineer']],
            personnelRecruitmentLists2: [['系統工程師(MIS)', 'JAVA 軟體工程師', '產品經理 (Product Manager)', '軟體測試工程師', '遊戲美術設計師'], ['系统工程师(MIS) ', 'JAVA 软件工程师 ', '产品经理 (Product Manager) ', '软件测试工程师', '游戏美术设计师 '], ['System Engineer (MIS)', 'Java Software Engineer', 'Product Manager', 'Software  Quality Assurance Manager', 'Game Artist']],
            infoButtonTestList: ['詳細連結', '详细连结', 'More Details'],
            personnelDescription: ['WORK HARD, PLAY HARD!<br>充滿活力的創樂科技提供具競爭性『薪酬』與超豐厚『福利』禮遇首先提供更從容的上班時間，公司採彈性上班制08:30AM~09:30AM，便利舒適的優質辦公室環境，搭配豐富零食與香醇可口的現煮咖啡，創作自己的職涯生活，除了上班時的活力，擁有頂尖優秀的團隊，有你的加入，將會更加強大，歡迎對軟體科技業充滿熱情且對自我工作能力充滿自信的你！', 'WORK HARD, PLAY HARD!<br>充满活力的创乐科技提供具竞争性『薪酬』与超丰厚『福利』礼遇首先提供更从容的上班时间，公司采弹性上班制08:30AM~09:30AM，便利舒适的优质办公室环境，搭配丰富零食与香醇可口的现煮咖啡，创作自己的职涯生活，除了上班时的活力，拥有顶尖优秀的团队，有你的加入，将会更加强大，欢迎对软件科技业充满热情且对自我工作能力充满自信的你！', 'WORK HARD, PLAY HARDER!<br>Chuangle provides competitive salary and  a generous compensation package.Flexible office hours. You can come to work from 08:30AM~09:30AM. Convenient and comfortable working environment with ample snacks and endless flow of brewed coffee. Create your own career with a great team. With you in our team, we will  be greater. If you are passionate with technology and confident with your skills, join us!'],
            recruitmentLists: [['DBA(SQL Server)資料庫管理員', 'Android資深工程師', 'iOS資深工程師', '資深C++軟體工程師', 'WEB前端工程師', '系統工程師(MIS)', 'JAVA 軟體工程師', '產品經理', '軟體測試工程師', '遊戲美術設計師'], ['DBA(SQL Server)数据库管理员 ', 'Android资深工程师', 'iOS资深工程师', '资深C++软件工程师 ', 'WEB前端工程师', '系统工程师(MIS) ', 'JAVA 软件工程师 ', '产品经理 (Product Manager) ', '软件测试工程师', '游戏美术设计师 '], ['Database Analyst (SQL Server)', 'Android Senior Engineer', 'iOS Senior Engineer', 'C++ Software Engineer', 'Web Front End Engineer', 'System Engineer (MIS)', 'Java Software Engineer', 'Product Manager', 'Software  Quality Assurance Manager', 'Game Artist']],

            selectedLanguage: 0
        };
    },

    methods: {
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            setTimeout(function () {
                _this.isAnimateChangeLanguageOn = false;
            }, 1);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
        });
        this.$root.$off('animageChangeLanguage', function (e) {
            _this.startChangeLangAnimation();
        });
        window.addEventListener('resize', function (e) {
            var h = document.getElementById('chuangPersonnel').offsetHeight;
            _this.$root.$emit('updatePerSize', h);
        });
        window.addEventListener('load', function (e) {
            var h = document.getElementById('chuangPersonnel').offsetHeight;
            _this.$root.$emit('updatePerSize', h);
        });
    }
});

/***/ }),

/***/ "kPgT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            clientWidth: 0,
            footerLanguages: [{
                address: '公司地址：台北市內湖區內湖路一段120巷15弄8號5樓',
                tel: '電話: (02) 2658-9898',
                fax: '傳真: (02)2658-3598'
            }, {
                address: '公司地址：台北市内湖区内湖路一段120巷15弄8号5楼',
                tel: '电话: (02) 2658-9898',
                tfaxel2: '传真: (02) 2658-3598'
            }, {
                address: '5F No.8, Aly. 15, Ln.120, Sec. 1, Neihu Rd., Neihu Dist., Taipei City 114, Taiwan(R.O.C)',
                tel: 'TEL: (02) 2658-9898',
                fax: 'FAX: (02) 2658-3598'
            }],
            selectedLanguage: 0
        };
    },

    methods: {
        changeIntroBackground: function changeIntroBackground() {
            if (this.clientWidth <= 900) {
                this.$refs.footerBgContainer.style.backgroundImage = "url(" + __webpack_require__("cQAS") + ")";
            } else if (this.clientWidth > 900) {
                this.$refs.footerBgContainer.style.backgroundImage = "url(" + __webpack_require__("dvsa") + ")";
            }
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
        });
        window.addEventListener('resize', function (e) {
            _this.clientWidth = document.getElementById('chuangFooter').clientWidth;
            _this.changeIntroBackground();
        });
        window.addEventListener('load', function (e) {
            _this.clientWidth = document.getElementById('chuangFooter').clientWidth;
            _this.changeIntroBackground();
        });
    }
});

/***/ }),

/***/ "llnD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mlNN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chuangPersonnel"}},[_c('div',{staticClass:"row hide-on-med-and-down"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col s12 m6 l6 xl6"},[_c('div',{class:{'personnel-recruitment-container':true}},[_c('h5',[_vm._v(_vm._s(_vm.personnelLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.personnelDescription[_vm.selectedLanguage])}}),_vm._v(" "),_c('div',{staticClass:"col m12 l6 xl6"},[_c('ul',_vm._l((_vm.personnelRecruitmentLists1[_vm.selectedLanguage]),function(item){return _c('li',{key:item.id},[_vm._v("\n                            "+_vm._s("● " + item)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"col m12 l6 xl6"},[_c('ul',_vm._l((_vm.personnelRecruitmentLists2[_vm.selectedLanguage]),function(item){return _c('li',{key:item.id},[_vm._v("\n                            "+_vm._s("● " + item)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"info-btn-container"},[_c('a',{attrs:{"href":"https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=414b456e5f6d4a6845593b21572f37608393b436c35373f683d433b1e1e1e1e631473b613270j49&jobsource=n104bank1"}},[_c('button',{domProps:{"textContent":_vm._s(_vm.infoButtonTestList[_vm.selectedLanguage])}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row hide-on-large-only"},[_c('div',{staticClass:"col s12 m12"},[_c('div',{class:{'personnel-recruitment-container':true}},[_c('h5',[_vm._v(_vm._s(_vm.personnelLanguages[_vm.selectedLanguage]))]),_vm._v(" "),_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.personnelDescription[_vm.selectedLanguage])}}),_vm._v(" "),_c('div',{staticClass:"col m6 l6 xl6"},[_c('ul',_vm._l((_vm.personnelRecruitmentLists1[_vm.selectedLanguage]),function(item){return _c('li',{key:item.id},[_vm._v("\n                            "+_vm._s(item)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"col m6 l6 xl6"},[_c('ul',_vm._l((_vm.personnelRecruitmentLists2[_vm.selectedLanguage]),function(item){return _c('li',{key:item.id},[_vm._v("\n                            "+_vm._s(item)+"\n                        ")])}))]),_vm._v(" "),_c('div',{staticClass:"info-btn-container"},[_c('a',{attrs:{"href":"https://www.104.com.tw/jobbank/custjob/index.php?r=cust&j=414b456e5f6d4a6845593b21572f37608393b436c35373f683d433b1e1e1e1e631473b613270j49&jobsource=n104bank1"}},[_c('button',{domProps:{"textContent":_vm._s(_vm.infoButtonTestList[_vm.selectedLanguage])}})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col s12 m6 l6 xl6"},[_c('div',{staticClass:"personnel-container-img"},[_c('img',{attrs:{"src":__webpack_require__("atO3"),"alt":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oPmM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8AK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"introBgContainer",attrs:{"id":"chuangIntroduction"}},[_c('div',{staticClass:"introduction-sub-container"},[_c('div',{class:{'introduction-placeholder': true}},[_vm._m(0),_vm._v(" "),_c('h5',{domProps:{"innerHTML":_vm._s(_vm.introTitleLanguages[_vm.selectedLanguage])}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.languageToDisplay[_vm.selectedLanguage])}})]),_vm._v(" "),_c('div',{attrs:{"id":"manageLink"}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-sub-image-container"},[_c('img',{staticClass:"introduction-sub-bg",attrs:{"src":__webpack_require__("8iO5"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sMYk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-sim-mb-bg.319f676.png";

/***/ }),

/***/ "uFD5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chuangHeader"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col s12 m12 l11 xl11"},[_c('div',{staticClass:"clearfix col-left"},[_vm._m(0),_vm._v(" "),_c('ul',{class:{'valign-wrapper right chuang-links hide-on-med-and-down': true , 
                                'list-adjust-margin': _vm.selectedLanguange !== 2,
                                'chuang-links-for-c-char': _vm.selectedLanguange !== 2}},_vm._l((_vm.headerLanguages),function(v,i){return _c('a',{attrs:{"href":v.link},on:{"click":function($event){_vm.showLanguange = false, _vm.startPageAnimation(i) }}},[_c('li',{class:{'left valign-wrapper': true, 'active-link': _vm.isActiveLink(i) },on:{"click":function($event){_vm.changeActiveLink(i), _vm.popModalShow(false)}}},[_c('p',{domProps:{"innerHTML":_vm._s(v.title[_vm.selectedLanguange])}})])])})),_vm._v(" "),(_vm.showList)?_c('img',{staticClass:"close right hide-on-large-only",attrs:{"src":__webpack_require__("/TeD"),"alt":""},on:{"click":function($event){_vm.show(false), _vm.popModalShow(false)}}}):_vm._e(),_vm._v(" "),(!_vm.showList)?_c('img',{staticClass:"hamburger right hide-on-large-only",attrs:{"src":__webpack_require__("DkvJ"),"alt":""},on:{"click":function($event){_vm.show(true), _vm.popModalShow(true)}}}):_vm._e()])]),_vm._v(" "),_c('div',{class:{'col l1 xl1 hide-on-med-and-down col-right valign-wrapper': true},on:{"click":function($event){_vm.showLanguange = !_vm.showLanguange, _vm.popModalShow(_vm.showLanguange)}}},[_c('p',{class:{'list-text-size-for-c-char': _vm.selectedLanguange !== 2, 
                        'arrow-down-eng': _vm.selectedLanguange == 2}},[_vm._v("\n                        "+_vm._s(_vm.languages[_vm.selectedLanguange])+" \n                        "),_c('span',{class:{'arrow-down': true}})])])]),_vm._v(" "),(_vm.showList)?_c('div',{staticClass:"mobile-list hide-on-large-only"},[_c('div',{staticClass:"row mobile-language-select"},[_c('a',{attrs:{"href":"#chuangIntroduction"}},_vm._l((_vm.languages),function(v,i){return _c('div',{class:{'col s4': true, 'c-char-space': _vm.isChineseChar(i), 'active': _vm.isSelected(i) },on:{"click":function($event){_vm.changeLanguage(i), _vm.popModalShow(false)}}},[_vm._v("\n                "+_vm._s(v)+"\n            ")])}))]),_vm._v(" "),_c('ul',{staticClass:"link"},_vm._l((_vm.headerLanguages),function(headerLink){return _c('a',{key:headerLink.id,attrs:{"href":headerLink.link},on:{"click":function($event){_vm.show(false), _vm.popModalShow(false)}}},[_c('li',{staticClass:"mobile-links-text clearfix"},[_c('img',{staticClass:"left",attrs:{"src":headerLink.icon,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"left"},[_vm._v(_vm._s(headerLink.char))]),_vm._v(" "),_c('p',{class:{'left':true, 'mobile-text-english': _vm.selectedLanguange == 2}},[_vm._v(_vm._s(headerLink.title[_vm.selectedLanguange]))])])])}))]):_vm._e(),_vm._v(" "),(_vm.showLanguange)?_c('div',{class:{'selectLanguage hide-on-med-and-down': true,
                                                            'animated fadeIn': _vm.showLanguange == true,
                                                                'animated fadeOutRight': _vm.showLanguange == false}},[_c('ul',_vm._l((_vm.languages),function(k,v){return _c('li',{domProps:{"innerHTML":_vm._s(k)},on:{"click":function($event){_vm.changeLanguage(v), _vm.popModalShow(false)}}})}))]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#chuangIntroduction"}},[_c('img',{staticClass:"left chuang-logo",attrs:{"src":__webpack_require__("KNZ0"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uW3H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isModalShow: false
        };
    },

    methods: {
        closeLanguageSelection: function closeLanguageSelection() {
            this.$root.$emit('closeLanguageSelection', false);
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$root.$on('popModalShow', function (e) {
            _this.isModalShow = e;
        });
    }
});

/***/ }),

/***/ "v8LC":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-trad-pc-bg.019ebd5.png";

/***/ }),

/***/ "w9y7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wctT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isPageStartAnimation: false,
            isAnimateChangeLanguageOn: false,
            competativeTitleLanguages: ['競爭優勢', '竞争优势', 'COMPETITIVE ADVANTAGE'],
            competativeLists: [['遊戲產業高度成長，亞太地區每年產值增加40%以上', '集聚多位國內資深軟體工程師及技術總監', '網路遊戲技術皆自行開發，技術卓越', '目前主要在東南亞拓建市場，未來將全球化佈局', '背景雄厚，資金健全', '創作自己的職涯生活，提供充滿競爭力的薪酬'], ['游戏产业高度成长，亚太地区每年产值增加40%以上', '集聚多位国内资深软件工程师及技术总监', '网络游戏技术皆自行开发，技术卓越', '目前主要在东南亚拓建市场，未来将全球化布局', '背景雄厚，资金健全', '创作自己的职涯生活，提供充满竞争力的薪酬'], ['Fast growth in the gaming industry. The annual output of the  gaming industry in  Asia-Pacific has increased 40%.', 'Conglomeration of senior software engineers and chief technical officer at home and abroad.', 'We develop online games independently with outstanding technology', 'As for now we are  expanding our market in  South East Asia. In the near future, we have plans to globalize our market.', 'Abundant technical background and solid financial strength.', 'Set your own career path and have a competitive compensation.']],
            selectedLanguage: 0
        };
    },

    methods: {
        test: function test() {
            console.log(true);
        },
        startChangeLangAnimation: function startChangeLangAnimation() {
            var _this = this;
            this.isAnimateChangeLanguageOn = true;
            this.selectedLanguage = parseInt(e);
        },
        startPageAnimation: function startPageAnimation() {
            this.isPageStartAnimation = true;
            timeout;
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$root.$on('languageChange', function (e) {
            _this.selectedLanguage = parseInt(e);
        });
        this.$root.$off('animageChangeLanguage', function (e) {
            _this.startChangeLangAnimation();
        });

        window.addEventListener('resize', function (e) {
            var h = document.getElementById('chuangCompetative').offsetHeight;
            _this.$root.$emit('updateCompSize', h);
            console.log(h);
        });
        window.addEventListener('load', function (e) {
            var h = document.getElementById('chuangCompetative').offsetHeight;
            _this.$root.$emit('updateCompSize', h);
            console.log(h);
        });
    },
    created: function created() {}
});

/***/ }),

/***/ "wr+2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-illustration-ch.4e74360.png";

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ChuangHeader__ = __webpack_require__("YPNJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ChuangIntroduction__ = __webpack_require__("XJGK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ChuangManagement__ = __webpack_require__("bk44");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ChuangCompetitive__ = __webpack_require__("I2rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ChuangCore__ = __webpack_require__("Yqm0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ChuangPersonnel__ = __webpack_require__("VvWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ChuangFooter__ = __webpack_require__("iDkQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_PopModal__ = __webpack_require__("9TKQ");
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    ChuangHeader: __WEBPACK_IMPORTED_MODULE_0__components_ChuangHeader__["a" /* default */],
    ChuangIntroduction: __WEBPACK_IMPORTED_MODULE_1__components_ChuangIntroduction__["a" /* default */],
    ChuangManagement: __WEBPACK_IMPORTED_MODULE_2__components_ChuangManagement__["a" /* default */],
    ChuangCompetitive: __WEBPACK_IMPORTED_MODULE_3__components_ChuangCompetitive__["a" /* default */],
    ChuangCore: __WEBPACK_IMPORTED_MODULE_4__components_ChuangCore__["a" /* default */],
    ChuangPersonnel: __WEBPACK_IMPORTED_MODULE_5__components_ChuangPersonnel__["a" /* default */],
    ChuangFooter: __WEBPACK_IMPORTED_MODULE_6__components_ChuangFooter__["a" /* default */],
    PopModal: __WEBPACK_IMPORTED_MODULE_7__components_PopModal__["a" /* default */]
  }
});

/***/ }),

/***/ "xSxi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/intro-bg-eng.bca1bdc.png";

/***/ }),

/***/ "xztD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ygJp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/core-sim-pc-bg.052279e.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js